import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 取消发货
 * @param params
 */
export const stopDeliveryApi = (item_id: number) => $http.get('/admin/merchant/cancel_shipment', { item_id, type: 2 })

/**
 * 获取物流公司列表
 * @param params
 */
export const getLogisticsCompanyApi = (params: object) => $http.get('/admin/merchant/get_express_code', params)

/**
 * 根据物流单号获取物流信息
 * @param params
 */
export const getExpressInfoApi = (express_no: string) => $http.get('/cake_api/getExpressNameByNo', { express_no })

/**
 * 订单分配门店保存
 * @param params
 */
export const saveDistributeApi = (order_id: string, take_shop_id: string, type?: number) => $http.post('/ptapi/order/allot_order', { order_id, take_shop_id, type })

/**
 * 门店确认接单/确认签收
 * @param params
 */
export const pickOrderApi = (order_id: string) => $http.post('/ptapi/order/affirm_order', { order_id })

/**
 * 获取当前登录用户待处理订单数据
 * @param params
 */
export const getUnResolveOrder = () => $http.get('/cake_api/check_shop_order', { notShowLoading: true })

/**
 * 获取特殊商品退款订单列表
 * @param params
 */
export const getRefundListApi = (params: object) => $http.get('/admin/merchant/getOrderRefundBearList', params)

/**
 * 商品特殊退款，商家承担一部分或全部费用。商家处理结果（是否同意）
 * id: 数据id
 * status：1-同意，2-拒绝
 * @param params
 */
export const updateRefundSplitAgreeApi = (id: number, status: number) => $http.post('/admin/merchant/RefundBearStatus', { id, status })

/**
 * 商品特殊退款，商务调整承担金额
 * order_no: 订单号
 * platform_bear：平台承担金额
 * business_bear：商户承担金额
 * @param params
 */
export const updateRefundSplitRateApi = (order_no: number, platform_bear: number, business_bear: number) => $http.post('/admin/merchant/RefundBearSave', { order_no, platform_bear, business_bear })

/**
 * 获取退款订单列表，用于商户弹框提醒（每10分钟轮循提醒）
 * @param params
 */
export const getWarningRefundOrderListApi = () => $http.get('/cake_api/quiteOrderNotice', { notShowLoading: true })

/**
 * 获取订单列表-商户用
 */
export const getOrderListApi = (params: object) => $http.get('/admin/merchant/getOrderList', params)

/**
 * 获取订单列表-内部员工用：创建时间为 2025-06-01 之后
 */
export const getAllOrderListApi = (params: object) => $http.get('/admin/merchant/getOrderLists', params)
/**
 * 获取历史订单列表-内部员工用：创建时间为 2025-06-01 之前
 */
export const getAllHistoryOrderListApi = (params: object) => $http.get('/admin/merchant/getOrderLists_history', params)


/**
 * 获取订单详情
 * @param id
 */
export const getOrderDetailApi = (order_id: string | number = '', order_no: string = '') => $http.get('/opsapi/orderDetails', { order_id, order_no })

/**
 * 保存订单
 * @param data
 */
export const saveOrderApi = (data: object) => $http.post('/opsapi/forwardToCiSave', { ...data })

/**
 * 更新订单项（退款、补偿等）
 * @param data
 */
export const updateOrderItemApi = (data: object) => $http.post('/admin/order/update_items', data)

/**
 * 订单罚款
 * @param data
 */
export const fineOrderApi = (data: object) => $http.post('/admin/order/fine_order', data)

/**
 * 订单超时罚款
 * @param data
 */
export const fineOrdersApi = (data: object) => $http.post('/admin/order/fine_orders', data)

/**
 * 工单罚款
 * @param data
 */
export const fineOrderWorkApi = (data: object) => $http.post('/admin/order/fine_order_work', data)

/**
 * 更新订单的 SKU
 * @param item_id 订单项 ID
 * @param sku 新的 SKU
 */
export const updateOrderSkuApi = (item_id: number | string, sku: string) => $http.post('/opsapi/do_sku', { item_id, sku })

/**
 * 获取罚款记录
 * @param order_item_id
 */
export const getFineRecordApi = (order_item_id: number | string) => $http.get('/opsapi/get_fine_record', { order_item_id })

/**
 * 保存罚款记录修改
 * @param fine_data
 */
export const updateFineRecordApi = (fine_data: any[]) => $http.post('/opsapi/upfine_record', { fine_data })

/**
 * 删除罚款记录
 * @param id
 */
export const delFineRecordApi = (id: number | string) => $http.post('/opsapi/del_record', { id })

/**
 * 工单回复并上传图片
 * @param data
 */
export const replyWorkOrderApi = (work_id: any, work_content: string = '', work_image: string = '') => $http.post('/opsapi/work_up_img', { work_id, work_content, work_image })

/**
 * 元祖推送
 * @param id // 订单ID
 */

export const yuanzuPushApi = (id: string | number) => $http.get('/dsapi/order/yuanzupush', { id, urlPrefix: '/ci_api' })

/**
 * 获取元祖推送结果
 * @param id // 订单ID
 */
export const getYuanzuPushResultApi = (id: string | number) => $http.get('/dsapi/order/get_yuanzu_pushs', { id, urlPrefix: '/ci_api' })

/**
 * 审核用户修改地址
 * @param data
 */
export const editServiceAddrApi = (data: object) => $http.post('/admin/order/sercvice_addr_edit', data)

/**
 * 获取地区列表
 * @param city
 */
export const getAreasApi = (city: string) => $http.get('/admin/order/get_areas', { city })

/**
 * 获取可配送门店列表
 * @param data
 */
export const getDeliveryShopApi = (data: object) => $http.post('/opsapi/get_delivery_addr', data)

/**
 * 发送短信通知
 * @param express_no
 * @param phone
 */
export const sendOrderMsgApi = (express_no: string, phone: string) => $http.post('/opsapi/send_msg', { express_no, phone })

/**
 * 获取物流进度
 * @param shipper
 * @param logistic
 * @param customer
 */
export const getKdLogisticsApi = (shipper: string, logistic: string, customer: string) => $http.get('/dsapi/order/kdapi', { shipper, logistic, customer })
//电影订单列表
export const getMovieOrderListApi = (params: object) => $http.get('/opsapi/movieOrderList', params)

// 电影订单详情
export const getMovieOrderDetailApi = (params: object) => $http.get('/opsapi/movieOrderInfo', params)

//电影订单退款
export const refundMovieOrderApi = (params: object) => $http.post('/opsapi/refundMovie', params)

// 获取平台在线点单列表
export const getStoreOrderListApi = (params: object) => $http.get('/opsapi/storeOrderList', params)

// 获取平台在线点单详情
export const getStoreOrderDetailApi = (order_id) => $http.get('/opsapi/storeOrderDetail', { order_id })

// 获取 SaaS 在线点单列表
export const getSaaSStoreOrderListApi = (params: object) => $http.get('/admin/fine_order/online_order_list', params)

// 获取 SaaS 在线点单详情
export const getSaaSStoreOrderDetailApi = (id) => $http.get('/admin/fine_order/online_order_detail', { id })

/**
 * 获取售后审核列表
 * @param params.type 1-仅退款，2-退货退款
 */
export const getAfterSaleListApi = (params: any) => $http.get(`${params.type == '1' ? '/opsapi/orderService' : '/opsapi/refundList'}`, params)

/**
 * 获取售后单详情
 * @param order_id  必填    订单ID
 * @param item_ids  选填    子订单ID，多个逗号分隔
 * @param spec_id   选填    商品规格ID，多个逗号分隔
 */
export const getAfterSaleDetailApi = (params: object) => $http.get('/opsapi/quitorderDetails', params)

/**
 * 获取用户提交的售后信息
 */
export const getAfterSaleUserInfoApi = (id: number | string) => $http.get('/refund/display', { id })

/**
 * 获取订单退款页面数据
 * @param params
 */
export const getRefundInfoApi = (params: object) => $http.get('/admin/order/quitorder', params)

/**
 * 保存订单退款
 * @param data
 */
export const saveRefundApi = (data: object) => $http.post('/opsapi/quitorderSave', data)

/**
 * 售后审核处理
 */
export const handleAfterSaleApi = (data: any) => $http.post('/opsapi/RefundGoodsHandle', { ...data })

/**
 * 仅退款驳回处理
 * @param id 订单ID
 * @param description 驳回原因
 */
export const refundRejectApi = (id: number | string, description: string) => $http.post('/opsapi/refuseSave', { id, description })

/**
 * 订单详情页退款申请、修改地址申请驳回处理
 * @param id 申请记录ID
 * @param status 状态 固定为 2，驳回
 * @param service_addr_default_test 驳回原因
 */
export const refundApplyRejectApi = (id: number | string, service_addr_default_test: string) => $http.post('/opsapi/sercviceAddrEdit', { id, status : 2, service_addr_default_test })

/**
 * 售后线下退款凭证上传
 */
export const uploadAfterSaleVoucherApi = (data: any) => $http.post('/opsapi/RefundGoodsPaymentvouchers', { ...data })

/**
 * 订单罚款
 * @param order_id  订单ID
 * @param order_item_id  订单项ID
 * @param type  罚款类型-1：普通罚款，2：工单罚款，3：超时罚款
 * @param finn_price  罚款金额
 * @param fine_remark  罚款备注
 */
export const saveFineApi = (data) => $http.post('/opsapi/fine_orders', data)

//黄牛用户列表
export const getHnUserList = (params: object) => $http.get('/admin/user/getHnUserList', params)

// 线下订单列表
export const getOfflineRecordsListApi = (params: object) => $http.get('/opsapi/offlineRecordsList', params)

//线下订单编辑
export const offlineRecordsEditApi = (params: object) => $http.post('/opsapi/offlineRecordsEdit', params)

//线下订单详情
export const offlineRecordsDetailApi = (params: object) => $http.get('/opsapi/offlineRecordsDetail', params)

// 线下订单下载上传模版
export const downloadExcelPladdApi = (params: object) => $http.get('/opsapi/downloadExcelPladd', params)

//  线下订单批量添加
export const doAddPlApi = (params: object) => $http.post('/opsapi/doAddPl', params)

//线下订单推送
export const pushOrderApi = (params: object) => $http.post('/opsapi/push_order', params)

// 获取异常快递订单列表
export const getAbnormalExpressOrderListApi = (params: object) => $http.get('/opsapi/getExpressUnusual', params)

// 获取延迟订单列表
export const getDelayOrderListApi = (params: object) => $http.get('/opsapi/deliveryOrderList', params)

// 延迟订单审核
export const updateDelayOrderStatusApi = (data: object) => $http.post('/opsapi/delivery_order_auth', data)

// 订单差价 order_id 订单id、item_id 子单idadjust_price 调整金额 、remark 调整原因
export const adjustOrderItemPriceApi = (data: object) => $http.post('/cake_api/adjustOrderItemPriceApi', data)


/****************************** 周边礼物（生日送礼物） ******************************/
/**
 * 获取订单列表
 * @param username  （选填）    收货人姓名
 * @param phone     （选填）    收货人联系方式
 * @param status    （选填）    状态：0-待领取，1-待发货，2-已发货
**/
export const getBirthdayActivityListApi = (params: object) => $http.get('/cake_api/merch_gift_order_list', params)

/**
 * 保存发货信息
 * @param id            （必填）    记录ID
 * @param express_company （必填）  快递公司
 * @param express_no    （必填）    快递单号
 * @param remark        （选填）    备注
**/
export const saveBirthdayShipInfoApi = (data: object) => $http.post('/cake_api/merch_gift_update_express', data)

/**
 * 生成专属送礼链接（填写收货地址页链接）
 * @param phone     （必填）    用户手机号
**/
export const getAddrLinkApi = (phone: number | string) => $http.post('/cake_api/merch_gift_create_link', { mobile: phone })
/****************************** 生日仪式感 - end ******************************/
